import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { CustomerAccountService } from '../../../../core/customer-account/customer-account.service';
import { ActivatedRoute, Router } from '@angular/router';
import { Observable, of, switchMap } from 'rxjs';
import { AuthService } from '@spartacus/core';
import { UserAccountFacade } from '@spartacus/user/account/root';

@Component({
  standalone: false,
  selector: 'app-waygate-hamburger-slider',
  templateUrl: './waygate-hamburger-slider.component.html',
  styleUrls: ['./waygate-hamburger-slider.component.scss'],
})
export class WaygateHamburgerSliderComponent implements OnInit {
  @Output() closeSlider = new EventEmitter();
  @Output() logOut = new EventEmitter();
  @Input() loggerIn: boolean;
  @Input() productLine;
  user$: Observable<any>;
  contactUsUrl: string = 'contactus';
  @Input() isChooseBrandPage: boolean = false;

  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private authService: AuthService,
    private userAccountFacade: UserAccountFacade,
  ) { }

  ngOnInit(): void {
    this.user$ = this.authService.isUserLoggedIn().pipe(
      switchMap((isUserLoggedIn) => {
        if (isUserLoggedIn) {
          return this.userAccountFacade.get();
        } else {
          return of(undefined);
        }
      })
    );
  }

  close() {
    this.closeSlider.emit();
  }

  signOut() {
    this.logOut.emit();
  }

  onRegisterClick() {
    this.router.navigate(['register'], { relativeTo: this.route });
  }

  navToLogin() {
    this.router.navigateByUrl('/login');
  }

  onAvatarClick() { }
}
